import { PlansQuery } from "@generated"
import { getGraphqlClient } from "@lib/graphql-client"
import { useCurrency } from "@lib/hooks/use-currency"
import { useQuery } from "@tanstack/react-query"

export type UsePlansPayload = {
  data: PlansQuery["plans"]
  refetch: () => void
}

const { sdk } = getGraphqlClient()
export const usePlans = (): UsePlansPayload => {
  const { currency } = useCurrency()
  const { data, refetch } = useQuery({
    queryKey: ["plans", currency],
    queryFn: async () => sdk.Plans({ currency }),
  })

  return { data: data?.plans ?? [], refetch }
}
